import { useMount } from 'react-use';

import {
   MedicalInformationFileUpload,
   MedicalInformationGenerateFileUploadUrlCommand,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import { useCqrsCommand } from '@dreryk/command-query-react-common';
import { commonTranslationKeys } from '@dreryk/react-common';
import {
   AttachmentsQrCodeUrl,
   dispatchSnackbarNegativeEvent,
   LoaderSpinner,
   Message,
   MessageType,
} from '@dreryk/react-components';

import { patientMedicalInformationTranslationKeys } from '../../../translations';

type MedicalInformationAttachmentsLoaderRenderProps = {
   qrCodeUrl: AttachmentsQrCodeUrl;
};

type MedicalInformationAttachmentsLoaderProps = {
   readonly medicalInformationId: number;
   readonly children: (renderProps: MedicalInformationAttachmentsLoaderRenderProps) => JSX.Element;
};

export const MedicalInformationAttachmentsLoader = (props: MedicalInformationAttachmentsLoaderProps): JSX.Element => {
   const {
      data: medicalInformationFileUpload,
      execute: generateAttachmentsQrCodeUrl,
      loading: medicalInformationFileUploadLoading,
      error: medicalInformationFileUploadError,
   } = useCqrsCommand<MedicalInformationFileUpload, void>(
      () => {
         const command = new MedicalInformationGenerateFileUploadUrlCommand();
         command.medicalInformationId = props.medicalInformationId;
         return command;
      },
      {
         onUnexpectedError: () => {
            dispatchSnackbarNegativeEvent(patientMedicalInformationTranslationKeys.qrCodeGenerateFailed);
         },
      }
   );

   useMount(() => {
      generateAttachmentsQrCodeUrl();
   });

   if (medicalInformationFileUploadError) {
      return (
         <Message
            testId={'error'}
            type={MessageType.NEGATIVE}
            label={commonTranslationKeys.unexpectedErrorHasOccurred}
            displayIndicator
         />
      );
   }

   if (medicalInformationFileUploadLoading || !medicalInformationFileUpload) {
      return <LoaderSpinner />;
   }

   return props.children({ qrCodeUrl: medicalInformationFileUpload.url as AttachmentsQrCodeUrl });
};
